import { type NotificationInboxItem } from "@/lib/data/requests";

export type NotificationCategory = "all" | "communication" | "standard";

export const isCommunicationNotification = (
  notification: Pick<NotificationInboxItem, "eventType">,
) =>
  notification.eventType.includes("EMAIL") ||
  notification.eventType.includes("SMS");

export const getSmsReplyTarget = (
  notification: Pick<NotificationInboxItem, "eventType" | "destination">,
) => {
  if (!notification.destination) return null;
  const { matterId, object } = notification.destination;
  if (
    !notification.eventType.startsWith("MATTER_SMS_") ||
    object?.type !== "contact_communication_sms" ||
    !object.contactId?.trim()
  ) {
    return null;
  }

  return {
    contactId: object.contactId,
    matterId,
  };
};

export const notificationMatchesCategory = (
  notification: Pick<NotificationInboxItem, "eventType">,
  category: NotificationCategory,
) =>
  category === "all" ||
  (category === "communication") === isCommunicationNotification(notification);
